import { render } from "./PopularCourses.vue?vue&type=template&id=552e5b6c"
import script from "./PopularCourses.vue?vue&type=script&lang=js"
export * from "./PopularCourses.vue?vue&type=script&lang=js"

import "./PopularCourses.vue?vue&type=style&index=0&id=552e5b6c&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__